<template>
    <div ref="doc" class="the-detail-body flex-grow-1">

        <page-scroll-top></page-scroll-top>
        <div class="product-info d-flex flex-column">
            <div class="name">
                <span class="name-cn">{{cnname}}</span>
                <span class="name-en">{{name}}</span>
            </div>
            <div class="describetion">{{describetion}}</div>
        </div>
        <div class="map-title">
            <span>成长地图</span>
            <span>由浅入深，带您轻松玩转 {{name}}</span>
        </div>
        <the-path-tree :menuList="mapList"></the-path-tree>
    </div>
</template>

<script>
import PageScrollTop from '../../../../components/page/page-scroll-top';
import ThePathTree from './the-path-tree.vue';
import { getProductMapList } from '../../service';

export default {
    name: 'ThePathBody',

    components: { PageScrollTop, ThePathTree },

    data() {
        return {
           mapList: [],
           describetion: '',
           name: '',
           cnname: ''
        };
    },

    computed: {
    },

    async created() {
        const res = await getProductMapList(this.$route.query.bookId);
        this.mapList = res.children;
        this.describetion = res.desc;
        this.name = res.name;
        this.cnname = res.cnname;
    },

    methods: {
    }
};
</script>

<style lang="scss" scoped>
    .the-detail-body {
        .product-info {
            justify-content: center;
            padding-left: 30px;
            color: #fff;
            height: 130px;
            background-image: url('../../../../assets/images/product-bg.png');
            background-repeat: no-repeat;
            background-size: cover;
            .name {
                margin-bottom: 10px;
                .name-cn {
                    font-size: 24px;
                    margin-right: 10px;
                }
            }
            .describetion {
                width: 400px;
            }
        }
        .map-title {
            margin: 40px 0 20px 0;
            span:nth-child(1) {
                font-size: 20px;
                margin-right: 15px;
            }
            span:nth-child(2) {
                color: #666666;
            }
        }
    }
</style>
